<ng-container *ngIf="show">
  <div class="subscribe__wrapper subscribe__wrapper--new">
    <div class="subscribe__inner">
      <div class="subscribe__title">Подпишитесь на&nbsp;рассылку</div>
      <div class="subscribe__description">Узнавай первым о новостях, акциях, скидках и спецпредложениях!</div>
    </div>
    <form class="subscribe__form" id="mainPageSubscribe" (ngSubmit)="onSubmit()">
      <div class="subscribe__input-wrapper">
        <app-input
          [formControl]="$any(subscriptionForm.get('email'))"
          [label]="'Email'"
          [required]="true"
        >
        </app-input>

      </div>
      <button class="button button--primary button--size-56" type="submit">Подписаться</button>
    </form>
  </div>
</ng-container>
